import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';

const Activity = () => {
    const { encryptedId } = useParams();
    const [activity, setActivity] = useState(null);
    useEffect(() => {
        const fetchActivity = async () => {
            const response = await window.apiClient.get(`/data/get/extra/${encryptedId}`);
            setActivity(response.data);
        };
        fetchActivity();
    }, [encryptedId]);

    const isJob = useMemo(() => !!activity && activity?.jobdesc?.length > 0, [activity]);
    const isProker = useMemo(() => !!activity && activity?.proker?.length > 0, [activity]);
    const isTeam = useMemo(() => !!activity && activity?.team_activity?.length > 0, [activity]);

    const job = useMemo(() => {
        return isJob ? activity.jobdesc.map(jobdesk => ({ nama_job: jobdesk.nama_job })) : [];
    }, [isJob, activity]);

    const proker = useMemo(() => {
        return isProker
            ? activity.proker.map(proker => ({
                  nama_proker: proker.nama_proker,
                  desc_proker: proker.desc_proker,
                  tujuan_proker: proker.tujuan_proker,
                  waktu_proker: proker.waktu_proker,
                  sasaran_proker: proker.sasaran_proker,
              }))
            : [];
    }, [isProker, activity]);

    const team = useMemo(() => {
        return isTeam
            ? activity.team_activity.map(team => ({
                  nama_team: team.nama_team,
                  nama_jabatan: team.jabatan.nama_jabatan,
                  url_image: team.url_image,
              }))
            : [];
    }, [isTeam, activity]);

    const getImageUrl = (url) => {
        return url
            ? `http://admin.sman2amlapura.sch.id/images/TeamActivity/${url}`
            : `http://admin.sman2amlapura.sch.id/images/TeamActivity/thm-user.png`;
    };

    if (!activity) {
        return <div className="flex justify-center items-center h-screen">Loading...</div>;
    }

    return (
        <div className="container px-4 py-8 mx-auto">
            <div className="mb-8 text-center">
                <h1 className="mb-2 text-3xl font-bold text-gray-800 uppercase">{activity.nama_activity}</h1>
                <p className="text-lg text-gray-600">{activity.short_desc_activity}</p>
            </div>

            <div className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800">Deskripsi</h2>
                <p className="mt-2 leading-relaxed text-gray-600">{activity.desc_activity}</p>
            </div>

            {isJob && (
                <div className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800">Tugas</h2>
                    <ul className="mt-4 list-disc list-inside">
                        {job.map((rowJob, index) => (
                            <li key={index} className="text-gray-600">{rowJob.nama_job}</li>
                        ))}
                    </ul>
                </div>
            )}

            {isProker && (
                <div className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800">Proker</h2>
                    <div
                        className={`grid grid-cols-${Math.min(proker.length, 3)} gap-6 mt-4
                        ${proker.length >= 2 ? 'md:grid-cols-2' : ''}
                        ${proker.length >= 3 ? 'lg:grid-cols-3' : ''}`}
                    >
                        {proker.map((rowProker, index) => (
                            <div key={index} className="p-4 bg-white rounded-lg shadow-lg">
                                <h3 className="mb-2 font-semibold text-gray-800">{rowProker.nama_proker}</h3>
                                <p className="mb-2 text-sm text-gray-600">{rowProker.desc_proker}</p>
                                <p className="mb-2 text-sm text-gray-600">Tujuan: {rowProker.tujuan_proker}</p>
                                <p className="mb-2 text-sm text-gray-600">Waktu: {rowProker.waktu_proker}</p>
                                <p className="text-sm text-gray-600">Sasaran: {rowProker.sasaran_proker}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {isTeam && (
                <div>
                    <h2 className="text-xl font-semibold text-gray-800">Anggota</h2>
                    <div className="grid grid-cols-1 gap-6 mt-4 md:grid-cols-2 lg:grid-cols-3">
                        {team.map((rowTeam, index) => (
                            <div
                                key={index}
                                className="p-4 bg-white rounded-lg shadow-lg transition duration-300 hover:shadow-xl hover:-translate-y-1 hover:scale-105"
                            >
                                <img
                                    className="object-cover mx-auto w-64 h-64 rounded-full md:w-48 md:h-48 lg:w-40 lg:h-40"
                                    src={getImageUrl(rowTeam.url_image)}
                                    alt={rowTeam.nama_team}
                                />
                                <h3 className="mt-4 text-lg font-semibold text-center text-gray-800">
                                    {rowTeam.nama_team}
                                </h3>
                                <p className="text-sm text-center text-gray-600">{rowTeam.nama_jabatan}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Activity;
